import {Button, DataStatus, Tooltip} from 'platform/components';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetVehicleV2Query} from '@dms/api/sales';
import {Occupant} from '@dms/api/warehouse';

import {suffixTestId, TestIdProps} from 'shared/web';

interface SpaceData {
  title: string;
  occupant: Occupant | undefined;
  value: number;
  isSelected: boolean;
  isOccupied: boolean | undefined;
  isOriginalSelected: boolean;
  isHidden: boolean | undefined;
}

export interface SectorButtonProps extends TestIdProps {
  space: SpaceData;
  onSpaceClick: (space: number) => void;
  index: number;
}

export function SectorButton(props: SectorButtonProps) {
  const {data: vehicleData, isLoading} = useGetVehicleV2Query(
    {vehicleId: props.space.occupant?.id ?? ''},
    {skip: isNilOrEmpty(props.space.occupant?.id)}
  );

  const isDisabled =
    !props.space.isSelected && !props.space.isOriginalSelected && props.space.isOccupied;

  return (
    <DataStatus isLoading={isLoading}>
      <Tooltip
        label={vehicleData?.registrationPlate ?? vehicleData?.title}
        isDisabled={!isDisabled}
      >
        <Button
          variant={props.space.isSelected ? 'primary' : 'secondary'}
          title={props.space.title}
          isDisabled={isDisabled}
          onClick={() => props.onSpaceClick(props.space.value)}
          data-testid={suffixTestId(`space-${props.index}`, props)}
          isFullWidth
        />
      </Tooltip>
    </DataStatus>
  );
}
